import { makeStyles } from '@/styles/theme/tss-react';

const useStyles = makeStyles({
  name: 'InputRow',
})(({ spacing, breakpoints }) => ({
  inputRow: {
    marginBottom: spacing(1),
    '&:last-of-type': {
      marginBottom: 0,
    },
    '& > *:first-of-type:not(:last-child)': {
      marginBottom: spacing(1),
    },
    display: 'flex',
    flexDirection: 'column',
    [breakpoints.up('sm')]: {
      '& > *:first-of-type:not(:last-child)': {
        marginBottom: 0,
      },
      flexDirection: 'row',
      '& > *:not(:last-child)': {
        marginRight: spacing(1),
      },
    },
  },
}));

export default useStyles;
